import React, { useEffect, useState } from 'react'
import MainHeading from '../../../components/comman/MainHeading';
import FilterComponent from '../../../components/comman/FilterComponent';
import CommonTable from '../../../components/comman/CommonTable';
import moment from 'moment';
import { calculateHours, formatTo12HourTime } from '../../../utility/CommonFunctions';
import { callApi } from '../../../ApiHelper/ApiHelper';
import { apiUrl } from '../../../ApiHelper/ApiUrl';
import { MainFilterHandler } from '../../../components/comman/MainFilterHandler';

export default function ExtraWorkUser() {
    const [state, setState] = useState({
        attendanceCount: null,
        attendanceList: [],
    });
    const [pageStates, setPageStates] = useState({
        currentPage: 1,
        pageSize: 10,
        count: 0,
        totalPages: 0,
        tableLoader: false,
        filterData: "",
        sortByDate: [
            moment().subtract(1, "month").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
        ],
        attendanceStatus: ""
    });

    const getMyExtraWork = (pageNo) => {
        let options = {
            method: "GET",
        };
        const Url = apiUrl.get_extra_work + "?" + MainFilterHandler(pageStates) + '&myExtraWork=true';
        setPageStates((pre) => ({
            ...pre,
            tableLoader: !pre.tableLoader
        }))
        callApi(Url, options).then((res) => {
            setPageStates((pre) => ({
                ...pre,
                tableLoader: !pre.tableLoader
            }))
            if (res?.status === true) {
                const newData = res?.data?.extraWork
                    ?.map((item) => ({
                        ...item,
                        startDate: moment(item?.startDate).format("DD/MM/YYYY"),
                        endDate: item?.endDate ? moment(item?.endDate).format("DD/MM/YYYY") : "--",
                        departmentName: item?.user?.department?.name,
                        officeName: item?.user?.site?.name,
                        siteName: item?.user?.usersites?.[0]?.site?.name,
                        startTime: item?.startDate && formatTo12HourTime(item?.startDate),
                        endTime:
                            item?.endDate && formatTo12HourTime(item?.endDate),
                        totalDuration:
                            item?.startDate &&
                            calculateHours(item?.startDate, item?.endDate),
                    }));
                setState((pre) => ({
                    ...pre,
                    attendanceList: newData,
                }));
                setPageStates((pre) => ({
                    ...pre,
                    count: res?.data?.pageInfo?.total,
                    totalPages: res?.data?.pageInfo?.totalPages,
                }))
            }
        })
    }
    const TableHeading = [
        { value: "index", label: "SR NO." },
        { value: "startDate", label: "Start Date" },
        { value: "endDate", label: "End Date" },
        { value: "departmentName", label: "Department" },
        { value: "siteName", label: "Site" },
        { value: "startTime", label: "Start Time" },
        { value: "endTime", label: "End Time" },
        { value: "totalDuration", label: "Total Duration" },
    ];

    useEffect(() => {
        getMyExtraWork()
    }, [pageStates.currentPage, pageStates.sortByDate, pageStates.pageSize]);

    const dateChangeHandler = (Dates) => {
        // console.log(Dates);
        let formattedDate = null;
        if (Dates && Dates.length === 2) {
            const startDate = new Date(
                Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
            )
                .toISOString()
                .slice(0, 10);
            const endDate = new Date(
                Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
            )
                .toISOString()
                .slice(0, 10);
            formattedDate = [startDate, endDate];
        }
        // console.log(formattedDate);
        if (formattedDate !== null) {
            setPageStates((prevState) => ({ ...prevState, sortByDate: formattedDate }))
        } else {
            setPageStates((prevState) => ({ ...prevState, sortByDate: "" }))
        }
    };
    const PageChangeHandler = (PageNo) => {
        // console.log("PageChangeHandler", PageNo);
        if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
            setPageStates((prev) => ({
                ...prev,
                currentPage: PageNo,
            }));
        }
    };
    const handleChangePageSize = (value) => {
        setPageStates((prev) => ({
            ...prev,
            pageSize: value,
            currentPage: 1
        }));
    };
    return (
        <>
            <div className="content">
                <MainHeading
                    title={"My Extra Work"}
                    dateChangeHandler={dateChangeHandler}
                // buttonText={"Apply Leave"}
                // buttonIcon={<PlusIcon />}
                // buttonLink={RoutesLink?.add_customer}
                // clickHandler={toggleModal}
                />
                <div className="card mb-4">
                    <div className="card-body">
                        <FilterComponent
                        // handleFilter={setPageStates}
                        // FilterData={pageStates}
                        // handleSearch={handleSearchChange}
                        // attendanceList={attendanceStatus}
                        // // handleFilterForAttendance={dateChangeHandler}
                        // handleFilterForAttendance={handleData}
                        />
                        <CommonTable
                            TableHeading={TableHeading}
                            TableData={state?.attendanceList}
                            // ActionData={ActionData}
                            currentPage={pageStates?.currentPage}
                            PageChangeHandler={PageChangeHandler}
                            isLoading={pageStates?.tableLoader}
                            totalPages={pageStates?.totalPages}
                            count={pageStates?.count}
                            handleChangePageSize={handleChangePageSize}
                            pageSize={pageStates.pageSize}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
